import React from 'react';

import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const moveOutChecklistForm: Form<Client> = {
  key: 'moveOutChecklist',
  title: 'Checkliste zum Auszug einer Frau',
  fields: [
    {
      key: 'movingOutDocument',
      label: 'Auszugsunterlagen ausgehändigt',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'movingOutJobCenterNotification',
      label: <b>Auszugtstag: Meldung an Jobcenter per E-Mail</b>,
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'movingOutEaServiceNotification',
      label: 'Auszugstag: EA-Dienst & Pfortenkraft informieren',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'chipReturn',
      label: 'Chip-Rückgabe',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'rentArrearsPaid',
      label: 'Mietrückstände beglichen',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'refundSecurityDeposit',
      label: 'Rückzahlung Kaution',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'refundDept',
      label: 'Rückzahlung Schulden',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'loanAgreement',
      label: 'Darlehensvertrag',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'roomInspection',
      label: 'Zimmerabnahme mit HM vereinbart',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'newAdressOnFile',
      label: 'Neue Adresse hinterlegt',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'bgNumberOnFile',
      label: 'BG-Nummer hinterlegt',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'housewarmingGift',
      label: 'Auszugsgeschenk',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'moveOutAdministrationNotification',
      label: 'Verwaltung über Auszug informieren',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'returnBorrowedItems',
      label: 'Geliehene Gegenstände zurück',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'moveOutNotes',
      label: 'Notizen',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default moveOutChecklistForm;
